import styles from '~/style/aigallery/component.module.less';
const SubTitle = ({data}) => {
    return (
        <div style={{textAlign: 'center'}}>
            <div className={styles['subTitle-box']}>
                <div className={styles.subTitle}>{data.subTitle}</div>
            </div>
        </div>
    );
};

export default SubTitle;
